import { typographyTokens } from '../../theme/typographyTokens';
import React from 'react';
import { Box, CircularProgress, Tooltip, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { SEPPhase, SEPSearchRow } from '../../../shared/types/SEP';
import { TaskStatus } from '../../../shared/types/Task';

type RequestProgressDialProps = {
  row: SEPSearchRow;
  size?: number;
};

const RequestProgressDial: React.FC<RequestProgressDialProps> = ({
  row,
  size = 40,
}) => {
  const theme = useTheme();
  const phaseTasks = (row.tasks || []).filter((task) =>
    [SEPPhase.validation, SEPPhase.initiate, SEPPhase.design, SEPPhase.implement].includes(
      task.phase
    )
  );
  const totalTasks = phaseTasks.length;
  const completedTasks = phaseTasks.filter((task) => task.status === TaskStatus.complete).length;

  const safeTotal = Math.max(totalTasks, 0);
  const safeCompleted = Math.max(completedTasks, 0);
  const percent = safeTotal > 0 ? Math.round((safeCompleted / safeTotal) * 100) : 0;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', py: 0.5 }}>
      <Tooltip title={`${safeCompleted} of ${safeTotal} tasks complete`}>
        <Box sx={{ position: 'relative', display: 'inline-flex' }}>
          <CircularProgress
            variant="determinate"
            value={percent}
            size={size}
            thickness={4}
            sx={{ color: theme.palette.solidBlue.main }}
          />
          <Box
            sx={{
              top: 0,
              left: 0,
              bottom: 0,
              right: 0,
              position: 'absolute',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Typography
              sx={{
                fontSize: typographyTokens.fontSizes.caption,
                fontWeight: typographyTokens.fontWeights.bold,
                lineHeight: 1,
                color: theme.palette.solidBlue.main,
              }}
            >
              {`${percent}%`}
            </Typography>
          </Box>
        </Box>
      </Tooltip>
    </Box>
  );
};

export default RequestProgressDial;
